import { Link } from "react-router-dom";

import { Dropdown, Col, Menu } from "antd";

import { deleteFromLocalStorage } from "helpers/localstorage";
import { useHistory } from "react-router-dom";
import avatarImg from "../../../assets/images/users/user-21.svg";
import { useRoutesSomethingChanged } from "context/RoutesCofirmChangesContext";

export default function HeaderUser() {
  const history = useHistory();

  const { somethingChanged, showUnsaveConfirm } = useRoutesSomethingChanged();

  const handleLinkClick = (event, to) => {
    if (somethingChanged) {
      event.preventDefault();
      showUnsaveConfirm(() => {
        history.push(to);
        deleteFromLocalStorage(["token", "isSuperAdmin"]);
      });
    } else {
      deleteFromLocalStorage(["token", "isSuperAdmin"]);
    }
  };

  const menu = (
    <Menu>
      <Menu.Item>
        <Link
          to="/"
          className="hp-p1-body hp-font-weight-500 hp-hover-text-color-primary-2"
          onClick={(e) => handleLinkClick(e, "/")}
        >
          Log out
        </Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <Col>
      <Dropdown overlay={menu} placement="bottomLeft">
        <div className="hp-border-radius-full hp-cursor-pointer">
          <div
            className="hp-border-radius-full hp-overflow-hidden hp-bg-info-4 hp-m-4 hp-d-flex"
            style={{ minWidth: 44, width: 44, height: 44 }}
          >
            <img src={avatarImg} alt="User" height="100%" />
          </div>
        </div>
      </Dropdown>
    </Col>
  );
}
